import React from 'react';

import {history} from 'core/history';

import {BreadCrumbItem, BreadcrumbWrapper} from './styled';

export type BreadcrumbsProps = {
    style?: React.CSSProperties;
    items: {label: string; link?: string; active?: boolean}[];
};
export const Breadcrumbs = ({items, style}: BreadcrumbsProps) => (
    <BreadcrumbWrapper style={style}>
        {items.map((item, i) => (
            <>
                {!!i && <span>/</span>}
                <BreadCrumbItem
                    active={item.link === history.location.pathname}
                    onClick={() => item.link && history.push(item.link)}
                >
                    {item.label}
                </BreadCrumbItem>
            </>
        ))}
    </BreadcrumbWrapper>
);
